import { FilterSelectionTypes } from "./filter.model";

export class FilterBar {
  filterBarId: string;
  filterBarName: string;
  filterBarItems: FilterBarItem[] = [];
}

export class FilterBarId {
  filterBarId: string;
}

export class FilterBarItem {
  ordinal: number;
  filterName: string;
  fieldNameToDisplay: string;
  filterBarItemType: FilterBarItemTypes = FilterBarItemTypes.Dataset;
  filterSelectionType: FilterSelectionTypes;
  datasetId: number;
  filterRuleIds: string[] = [];
}

export class FilterBars {
  filterBars: FilterBar[] = [];

  constructor() {
    this.filterBars = [];
  }
}

export enum FilterBarItemTypes {
  Dataset = 'Dataset',
  Custom = 'Custom',
}
